<script>
  export default {
    name: 'paddle-list-item',
    props: ['item'],
    computed: {
      imagePath () {
        return require("@/assets/images/uploads/paddles/" + this.item.slug + ".png")
      },
      getPricing() {
        if (this.item.pricing == null) {
          return '-'
        }
        return this.item.pricing.amount + " " + this.item.pricing.currencySymbol
      },
      getPaddlockPricing() {
        if (this.item.pricingPaddlock == null) {
          return 'NO'
        }
        return this.item.pricingPaddlock.amount + " " + this.item.pricingPaddlock.currencySymbol
      },
      isPricingVisible() {
        return this.item.slug.toLowerCase() != "paddlock-system"
      },
      isPaddlockOptionVisible() {
        return this.item.slug.toLowerCase() != "paddlock-system"
      }
    }
  }
</script>
<template>
  <b-col
    md="6"
    class="mt-5">
    <b-card
      header-bg-variant="dark"
      header-text-variant="white"
      no-body>
      <template #header>
        <h5
          class="mb-0 uppercase">
          {{ item.name }}
        </h5>
      </template>
      <b-card-body>
        <b-card-img
          :src="imagePath">
        </b-card-img>
        <b-list-group
          flush
          class="mt-4">
          <b-list-group-item
            class="d-flex justify-content-between align-items-center">
            <span class="section-item">
              Lunghezza
            </span>
            <b-badge variant="light" pill>
              {{ item.length }} cm
            </b-badge>
          </b-list-group-item>
          <b-list-group-item
            class="d-flex justify-content-between align-items-center">
            <span class="section-item">
              Peso
            </span>
            <b-badge variant="light" pill>
              {{ item.weight }} gr
            </b-badge>
          </b-list-group-item>
          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
            v-if="isPricingVisible">
            <span class="section-item">
              Prezzo
            </span>
            <b-badge variant="light" pill>
              {{ this.getPricing }}
            </b-badge>
          </b-list-group-item>
          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
            v-if="isPaddlockOptionVisible">
            <span class="section-item">
              Opzione paddlock
            </span>
            <b-badge variant="light" pill>
              {{ this.getPaddlockPricing }}
            </b-badge>
          </b-list-group-item>
        </b-list-group>
      </b-card-body>
    </b-card>
  </b-col>
</template>
<style scoped>
  .section-item {
    text-transform: uppercase;
  }
</style>